import { getCookie } from '@/utils'

import { EXPERIENCE_VARIANTS, EXPERIENCES } from './userExperienceInitializer/userExperience.data'
import { UserExperiences } from './userExperience.types'

export const useUserExperiences = (): UserExperiences => {
  const reviewPageCookie = getCookie(EXPERIENCES.EXP_REVIEW_PAGE)
  // const directCheckoutCookie = getCookie(EXPERIENCES.EXP_DIRECT_CHECKOUT)

  return {
    isReviewEnabled: !reviewPageCookie || reviewPageCookie === EXPERIENCE_VARIANTS.DEFAULT,
    isDirectCheckoutEnabled: false, // directCheckoutCookie === EXPERIENCE_VARIANTS.ENABLED,
  }
}
